/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/naming-convention */
import { getQueryParam } from './helper';
import { CompanySearchResp, GetESignApiSuccessResponse, GetESignResponse } from './types';
import api from '.';
import { API_ENDPOINTS } from '@/constants';

export const searchCompany = async (text: string): Promise<CompanySearchResp> => {
  const paymentId = getQueryParam('id') || '';
  // eslint-disable-next-line new-cap
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.COMPANY_SEARCH(paymentId)}`,
    {
      text,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      page_no: '0',
      count: '20',
    },
    {
      method: 'GET',
    },
  );

  if (response.ok) {
    const data = (await response.json()) as CompanySearchResp;
    return data;
  }

  throw new Error('Error fetching companies');
};

export const verifyIncome = async ({
  id,
  name,
  email,
}: {
  id: string;
  name: string;
  email: string;
}): Promise<GetESignResponse> => {
  const paymentId = getQueryParam('id') || '';
  const response = await api(
    // eslint-disable-next-line new-cap
    `${API_ENDPOINTS.VERIFY_INCOME(paymentId)}`,
    {},
    {
      method: 'POST',
      body: JSON.stringify({
        company_name: name,
        company_id: id,
        company_email: email,
      }),
    },
  );

  if (response.ok) {
    const data = (await response.json()) as GetESignApiSuccessResponse;
    return { success: true, url: data.next?.url };
  }

  throw new Error('Error verifying income');
};
